import store from '../../store/index.js'
import axios from 'axios'
import {
  throwStatement,
} from '@babel/types'

function fetchFormById (id, next) {
  axios.get('/forms/' + id).then(result => {
    let form = result.data
    store.dispatch('setForm', form)

    fetchConstentsByFormId(next)
  })
}

/**
 * Fetch form consents and question
 * To be used when part of the info is already loaded on the page
 **/

function fetchFormInfo (id, next) {
  axios.get('/forms/fetchFormInfo/' + id).then(result => {
    let data = result.data

    store.dispatch('setFormQuestion', data.formQuestion)
    store.dispatch('setFormConsents', data.formConsents)

    fetchConstentsByFormId(next)
  })
}

function fetchConstentsByFormId (next) {
  let storeConsents = []
  const formConsents = store.getters.form.formConsents

  Object.assign(storeConsents, store.getters.consents)
  // Fetch all consents for editing
  if (store.getters.clearance) {
    axios.get('/consents/isInForm/' + false).then(result => {
      let data = result.data
      let consents = data.titleAndFormIdConsentDTOS

      store.dispatch('setConsents', consents)

      next()
    })
  } else {
    next()
  }
}

export const formRoutes = [

  {
    path: '/consentForms/',
    component: () => import('../../components/consentForms/landing/Forms.vue'),
    children: [{
      name: 'consentForms',
      path: '',
      component: () => import('../../components/consentForms/landing/ViewConsentForm.vue'),
    },
    {
      name: 'createForm',
      path: 'create',
      component: () => import('../../components/consentForms/create/CreateConsentForm.vue'),
    },
    {
      name: 'editForm',
      path: ':id',
      props: true,
      component: () => import('../../components/consentForms/edit/EditForm.vue'),
      beforeEnter: (to, from, next) => {
        let form = store.getters.form

        if (form._id == undefined) {
          fetchFormById(to.params.id, next)
        } else {
          fetchFormInfo(form._id, next)
        }
      },
    },
    ],
  }
]